var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Content',{on:{"content-loaded":_vm.setBreadcrumb}})
}
var staticRenderFns = []

export { render, staticRenderFns }